export const MAX_AMOUNT_OF_USERS_FOR_STARTER_PLAN = 3
export const MAX_AMOUNT_OF_USERS_FOR_FREE_PLAN = 5
